import { render, staticRenderFns } from "./AddEditType.vue?vue&type=template&id=5901317d&"
import script from "./AddEditType.vue?vue&type=script&lang=js&"
export * from "./AddEditType.vue?vue&type=script&lang=js&"
import style0 from "./AddEditType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports